<form [formGroup]="userForm" (ngSubmit)="onSubmit()" autocomplete="off" class="grid">
  <div class="flex col-12 p-0 justify-content-center align-items-center">
    <div [ngClass]="isCreateMode ? 'col-12' : 'col-10'">
      <label for="firstName" class="block text-sm font-medium mb-2">Name *</label>
      <input
        id="firstName"
        type="text"
        pInputText
        formControlName="firstName"
        placeholder="Enter name"
        class="w-full"
        [class.ng-invalid]="isFieldInvalid('firstName')"
      />
      <small class="p-error" *ngIf="isFieldInvalid('firstName')">
        Name is required
      </small>
    </div>
    @if (!isCreateMode) {
      <div class="col-2">
        <label for="active" class="block text-sm font-medium mb-2">Status</label>
        <p-inputSwitch id="active" formControlName="active"/>
      </div>
    }
  </div>
  <div class="col-12">
    <label for="lastName" class="block text-sm font-medium mb-2">Surname *</label>
    <input
      id="lastName"
      type="text"
      pInputText
      formControlName="lastName"
      placeholder="Enter surname"
      class="w-full"
      [class.ng-invalid]="isFieldInvalid('lastName')"
    />
    <small class="p-error" *ngIf="isFieldInvalid('lastName')">
      Surname is required
    </small>
  </div>

  <div class="col-12">
    <label for="email" class="block text-sm font-medium mb-2">Email *</label>
    <input
      id="email"
      type="email"
      pInputText
      formControlName="email"
      placeholder="Enter email"
      class="w-full"
      [class.ng-invalid]="isFieldInvalid('email')"
    />
    <small class="p-error" *ngIf="isFieldInvalid('email')">
      Please enter a valid email address
    </small>
  </div>

  @if (isCreateMode) {

    <div class="col-12">
      <label for="username" class="block text-sm font-medium mb-2">Username *</label>
      <input
        id="username"
        type="text"
        pInputText
        formControlName="username"
        placeholder="Enter username"
        class="w-full"
        [class.ng-invalid]="isFieldInvalid('username')"
      />
      <small class="p-error" *ngIf="isCreateMode && isFieldInvalid('username')">
        Username is required
      </small>
    </div>

    <div class="col-12">
      <label for="password" class="block text-sm font-medium mb-2">Password *</label>
      <input
        id="password"
        type="password"
        pInputText
        formControlName="password"
        placeholder="Enter password"
        class="w-full"
        autocomplete="new-password"
        [class.ng-invalid]="isFieldInvalid('password')"
      />
      <small class="p-error" *ngIf="isCreateMode && isFieldInvalid('password')">
        Password is required
      </small>
    </div>

  }

  <div class="col-12 flex gap-2 justify-content-end">
    <button
      type="button"
      pButton
      label="Cancel"
      icon="pi pi-times"
      class="p-button-outlined"
      (click)="onCancel()"
    ></button>
    <button
      type="submit"
      pButton
      label="Save"
      icon="pi pi-check"
      class="p-button-primary"
      [disabled]="!userForm.valid"
    ></button>
  </div>
</form>
